import RadioButton from '@/components/basicComponents/radioButton';
import { ErrorText } from '@/components/basicComponents/input';
import Label from '@/components/basicComponents/label';
import { buildTestId } from '@/lib/utils/testIds';
import { Controller, useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { IRenderTemplateField } from '../../types';

interface RadioComponentProps {
  field: IRenderTemplateField;
  pageName?: string;
  ignoreRequired: boolean;
}

const getSelectedOption = (value: any, items: any): string => {
  if (value === undefined) return '';
  return items.find((item: any) => item.value === value)?.label || '';
};

export const RadioComponent = ({ field, pageName = '', ignoreRequired }: RadioComponentProps) => {
  const { name, label, validation, config } = field;
  const items = config?.items || [];
  const { control } = useFormContext();

  return (
    <div>
      {label && (
        <Label size="md" required={!!validation?.required && !ignoreRequired}>
          {label}
        </Label>
      )}
      <Controller
        name={`${pageName}.${name}`}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <>
            <RadioButtonsWrapper>
              {items.map((item: any, index: number) => (
                <RadioButton
                  key={item + index}
                  name={name}
                  radioButtonText={item.label}
                  selectedOption={getSelectedOption(value, items)}
                  handleRadioChange={(event) => {
                    onChange(items.find((item: any) => item.label === event.target.value)?.value);
                  }}
                  data-testid={item.label && name ? buildTestId('signature-packet', pageName, name, item.label) : undefined}
                />
              ))}
            </RadioButtonsWrapper>
            {error?.message && <ErrorText size="md">{error?.message}</ErrorText>}
          </>
        )}
      />
    </div>
  );
};

const RadioButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
